import { UIManager } from '@/Core/Managers/UI'
import type { IUIManagerConfig } from '@/Core/Contracts/UI/UIManager'
import { action, makeObservable, observable } from 'mobx'
import React from 'react'

interface HeaderPageStoreConfig extends IUIManagerConfig {
    title?: React.ReactNode | false
    titleExtra?: React.ReactNode[]
    afterExtra?: React.ReactNode[]
    extra?: React.ReactNode[]
}

export class HeaderPageStore extends UIManager {
    title: React.ReactNode | false = false
    titleExtra: React.ReactNode[] = []
    extra: React.ReactNode[] = []
    afterExtra: React.ReactNode[] = []
    
    constructor({ title, titleExtra, afterExtra, extra, ...props }: HeaderPageStoreConfig = {}) {
        // Встановлюємо contextKey для HeaderPage
        props.contextKey = 'headerPageContext'
        
        super(props)

        makeObservable(this, {
            title: observable,
            setTitle: action,
        })

        if (title !== undefined) this.setTitle(title)

        if (Array.isArray(titleExtra)) this.titleExtra = titleExtra

        if (Array.isArray(extra)) this.extra = extra

        if (Array.isArray(afterExtra)) this.afterExtra = afterExtra
    }

    setTitle(title: React.ReactNode | false): void {
        this.title = title
    }
}
